export function downloadFile(file: File): void {
  const fileLink = document.createElement('a');

  fileLink.href = globalThis.URL.createObjectURL(file);
  fileLink.setAttribute('download', file.name);

  document.body.appendChild(fileLink);
  fileLink.dispatchEvent(new MouseEvent('click'));

  fileLink.remove();
}
